import React, { useState, useEffect } from "react";
import dayjs from 'dayjs';
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CircularProgress from '@mui/joy/CircularProgress';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { BASE_URL } from '../../../constant/index';
import { useAuth } from "../../../context/AuthProvider";

const AddNotification = ({
    openAddNotificationModal, 
    setAddNotificationModalOpen,
    setSuccessMsg,
    setErrorMsg,
    setLoading,
    isLoading,
}) => {
    const { token } = useAuth();
    const [ input, setInput ] = useState({
        title: '',
    });

    const handleCloseNotifications = () => setAddNotificationModalOpen(false);

    const notificationsAction = async (e) => {
        e.preventDefault();
        setSuccessMsg('');
        setErrorMsg('');
        if (input.title.trim() !== '') {
            setLoading(true);
            try {
                const { data } = await axios.post(BASE_URL+'/saveNotification', { input: {
                    ...input,
                    title: input.title.trim(),
                } }, {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });
                if(data?.msg) {
                    setSuccessMsg(data.msg);
                }
                setLoading(false);
            } catch(err) {
			    setErrorMsg('Server encountered an issue, please try later. If issue still persist, please reach out on help@capitaltrends.in');
			    setLoading(false);
		    } finally {
                setAddNotificationModalOpen(false);
                setInput({
                    title: '',
                });
            }
        }
    }

    const onTitleChange = (event) => {
        setInput(prevState => ({
            ...prevState,
            title: event.target.value,
        }));
    }

    return (
        <Dialog
            open={openAddNotificationModal}
            onClose={handleCloseNotifications}
            maxWidth='sm'
            fullWidth={true}
        >
            <DialogContent>
                <DialogContentText component={'div'}>
                    <form onSubmit={notificationsAction} >
                        <Stack spacing={4}>
                            <TextField 
                                id="title"
                                label="Add Notification"
                                onChange={onTitleChange}
                                variant="standard" 
                            />
                        </Stack>

                        <div className="d-flex mt-3">
                            <button type="submit" className="btn btn-primary mb-4">{isLoading ? (<CircularProgress size="sm" />) : 'Submit'}</button>
                        </div>
                    </form>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseNotifications}>close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddNotification;